// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-layout .admin-panel-tab .tab-wrapper {
  width: 100%;
}
.admin-layout .admin-panel-tab .tab-wrapper .tab-label {
  text-align: center;
}
.admin-layout td:has(.row-container.action-items-list),
.admin-layout th:has(.column-header.action_items),
.admin-layout .column-header.action_items,
.admin-layout .row-container.action-items-list {
  width: 80px !important;
}
.admin-layout .toggle-wrapper .label {
  font-size: 16px !important;
  font-weight: 400 !important;
}
.admin-layout .admin-events-list table {
  height: calc(100vh - 390px);
}
.admin-layout .admin-events-list .table-header-container {
  align-items: end !important;
}
.admin-layout .admin-events-list .table-header-container .dropdown-selector {
  height: 40px;
}
.admin-layout .admin-requested-events-list table {
  height: calc(100vh - 320px);
}
.admin-layout .venue-list-table table {
  height: calc(100vh - 290px);
}
.admin-layout .venue-list-table .table-header-container {
  align-items: end !important;
}`, "",{"version":3,"sources":["webpack://./src/routes/admin-panel/admin-listing/style.scss"],"names":[],"mappings":"AAEI;EACE,WAAA;AADN;AAGM;EACE,kBAAA;AADR;AAME;;;;EAIE,sBAAA;AAJJ;AAOE;EACE,0BAAA;EACA,2BAAA;AALJ;AAUE;EACE,2BAAA;AARJ;AAWE;EACE,2BAAA;AATJ;AAWI;EACE,YAAA;AATN;AAeE;EACE,2BAAA;AAbJ;AAkBE;EACE,2BAAA;AAhBJ;AAmBE;EACE,2BAAA;AAjBJ","sourcesContent":[".admin-layout {\n  .admin-panel-tab {\n    .tab-wrapper {\n      width: 100%;\n    \n      .tab-label {\n        text-align: center;\n      }\n    }\n  }\n\n  td:has(.row-container.action-items-list),\n  th:has(.column-header.action_items),\n  .column-header.action_items,\n  .row-container.action-items-list {\n    width: 80px !important;\n  }\n\n  .toggle-wrapper .label {\n    font-size: 16px !important;\n    font-weight: 400 !important;\n  }\n\n\n.admin-events-list {\n  table {\n    height: calc(100vh - 390px);\n  }\n\n  .table-header-container {\n    align-items: end !important;\n\n    .dropdown-selector {\n      height: 40px;\n    }\n  }\n}\n\n.admin-requested-events-list {\n  table {\n    height: calc(100vh - 320px);\n  }\n}\n\n.venue-list-table {\n  table {\n    height: calc(100vh - 290px);\n  }\n\n  .table-header-container {\n    align-items: end !important;\n  }\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
